




































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { ItemDataUpdate } from 'src/assets/ItemDataLive'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import ButtonRetakes from 'components/presenter/item/course/student/GradebookSettingsButtonRetakes.vue'
import ButtonWeight from 'components/presenter/item/course/student/GradebookSettingsButtonWeight.vue'
import api from 'src/assets/api/gql'
import ItemUpdateData from 'src/graphql/item/ItemUpdateData.gql'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    ButtonRetakes,
    ButtonWeight
  }
})
export default class ItemCourseGradebookSettings extends Vue {
  changed = false

  @Prop({ default: () => new Map() })
  readonly topics!: Map<string, Item>

  @Ref()
  readonly dialog!: DialogFullscreen

  get gradebook () {
    return
  }

  get weightTotal () {
    return [...this.topics.values()].reduce((total: number, topic: Item) => total + (topic?.data?.info?.gradebook?.weight || 0), 0)
  }

  async save (topic: Item, option: string, value: any) {
    const data = { infoSettings: {} } as ItemDataUpdate
    // @ts-ignore
    data.infoSettings[ 'gradebook:' + option ] = value || null
    await api.mutate({
      query: ItemUpdateData,
      variables: {
        input: { id: topic.id, data }
      }
    })
    topic.data?.update(data)
    this.$emit('update')
    this.changed = true
  }

  close () {
    this.dialog.hide()
    !this.changed || this.$emit('change')
  }
}
